import * as React from "react";
import { FormattedMessage } from "react-intl";
import { HooplaPurchase } from "types";
import Typography from "components/Typography";
import TicketCard from "components/TicketCard";
import * as styles from "./styles";

interface IProps {
  list: HooplaPurchase[];
}

const TicketList: React.FC<IProps> = (props) => {
  const [ended, setEnded] = React.useState([]);
  const [future, setFuture] = React.useState([]);

  React.useEffect(() => {
    let date = new Date();
    setEnded(
      props.list
        .filter((it) => new Date(it.event.end) < date)
        .sort((a, b) => (a.event.start > b.event.start ? -1 : 1)),
    );
    setFuture(
      props.list
        .filter((it) => new Date(it.event.end) > date)
        .sort((a, b) => (a.event.start > b.event.start ? 1 : -1)),
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (props.list.length === 0) {
    return (
      <React.Fragment>
        <Typography type="subheading">
          <FormattedMessage id="components.TicketList.emptyView" />
        </Typography>
      </React.Fragment>
    );
  }

  return (
    <React.Fragment>
      {future.length !== 0 && (
        <div className={styles.container}>
          <h2>
            <FormattedMessage id={"components.TicketList.later"} />{" "}
          </h2>
          {future.map((purchase) => (
            <TicketCard purchase={purchase} key={purchase.event.eventId} />
          ))}
        </div>
      )}
      {ended.length !== 0 && (
        <div className={styles.container}>
          <h2>
            <FormattedMessage id={"components.TicketList.ended"} />{" "}
          </h2>
          {ended.map((purchase) => (
            <TicketCard purchase={purchase} key={purchase.event.eventId} />
          ))}
        </div>
      )}
    </React.Fragment>
  );
};

export default TicketList;
